import axios from "axios";

// Enable credentials (cookies) for all axios requests
axios.defaults.withCredentials = true;

// Use REACT_APP_API_URL env var if set, otherwise default to localhost for local dev
const host = window.location.hostname;
//const BASE_API_URL = `http://${host}:8080/`;

//Local
//const BASE_API_URL = `${window.location.protocol}//${host}:8080/`;



// Production
const isLocal = window.location.hostname === "localhost";

const BASE_API_URL = isLocal
  ? `${window.location.protocol}//${window.location.hostname}:8080/`
  : `${window.location.protocol}//${window.location.host}/`;



// const isLocal = window.location.hostname.includes("localhost");

// const BASE_API_URL = isLocal
//   ? "http://localhost:8080/"
//   : `${window.location.protocol}//${window.location.host}/`;

//const BASE_API_URL = process.env.REACT_APP_API_URL || "http://localhost:8081/";
const PUBLIC_API_URL = BASE_API_URL + "api/public/";
const PRIVATE_API_URL = BASE_API_URL + "api/private/";

export const getPublicURL = () => { return PUBLIC_API_URL; };
export const getPrivateURL = () => { return PRIVATE_API_URL; };

axios.interceptors.request.use(config => {
  if (config.method === 'POST' || config.method === 'PATCH' || config.method === 'PUT')
    config.headers['Content-Type'] = 'application/json;charset=utf-8';

  // const accessToken = AuthService.getAccessToken();
  if (localStorage.getItem("Authentication"))
    config.headers.Authorization =  localStorage.getItem("Authentication");

  return config;
});

const CoreService = {
  getPrivateURL,
  getPublicURL,
  BASE_API_URL,
};
export default CoreService;
